import { NewsCard } from '../news-card/NewsCard.tsx'
import type { NewsStory } from '../news-front/NewsFront.tsx'
import styles from './RelatedStories.module.css'

export interface RelatedStoriesProps {
  /** Heading over the cards, e.g. "More from Pacific Rift League". */
  title: string
  stories: NewsStory[]
  /** The wide banner under the cards. */
  next?: NewsStory
  nextLabel?: string
  className?: string
}

/** The end of an article: up to three related stories, then the next one. */
export function RelatedStories({ title, stories, next, nextLabel = 'Next story →', className }: RelatedStoriesProps) {
  const cards = stories.slice(0, 3)
  if (cards.length === 0 && !next) return null

  return (
    <section className={[styles.related, className].filter(Boolean).join(' ')} aria-label={title}>
      {cards.length > 0 && (
        <>
          <h2 className={styles.title}>{title}</h2>
          <div className={styles.grid}>
            {cards.map((s) => (
              <NewsCard
                key={s.id}
                to={s.to}
                title={s.title}
                coverUrl={s.coverUrl}
                kicker={s.kicker}
                date={s.date}
                readTimeMinutes={s.readTimeMinutes}
              />
            ))}
          </div>
        </>
      )}
      {next && (
        <NewsCard
          variant="banner"
          eyebrow={nextLabel}
          to={next.to}
          title={next.title}
          coverUrl={next.coverUrl}
          as="h2"
        />
      )}
    </section>
  )
}
